<editor
	class="h-full"
	[init]="tinyMCEInit"
	[(ngModel)]="document"
	(ngModelChange)="updateContent($event)"
	(onInit)="editorReady($event)"
	[disabled]="disabled"
></editor>
